export default {
  production: true,
  app: {
    bundle: 'unowtve',
    name: 'unowtve',
    xClientID: 'unow-unowtve',
    appBuild: 29,
    applicationId: '673195753',
    appName: 'unowtve-comecast-ui-prod',
    majorVersion: '0',
    minorVersion: '0',
    patchVersion: '1',
    appVersionId: '673198239',
    asn: '52362',
    asnowner: 'Servicios Innovadores de Comunicacion y Entretenimiento, S.A.',
  },
  conviva: {
    ckey: 'd0af5e863cae7cdd87dd6865d97dc2e096d7425a',
    gUrl: 'https://d0af5e863cae7cdd87dd6865d97dc2e096d7425a.ts-testonly.conviva.com',
  },
  adobe: {
    adobeSoftwareStatement:
      'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJmZGZlNmRlYi0xMGI0LTQzMmQtODVjYy04MDc1NzdmYzc3NWEiLCJuYmYiOjE3NzY0NDg3MzYsImlzcyI6ImF1dGguYWRvYmUuY29tIiwiaWF0IjoxNzc2NDQ4NzM2fQ.L49ravU_edCfJoBwrs5UgkDGE3Bc4wjplwOCsGOWx0f2T2rdb5YFH2s4J08nHAO9JqqBGsxLtgKVJ3DOD-KBiLoorLtUFZOiFmRv2p7qmEjOBd47HQZ94VszSImsLHaliwlz3Ipc9OIUyBaz4rzeNcVeMbCK8U3baw7WFznQWsCdFm1D9yvYNK2JpkniSy908rn0sJb9RtHT3NbX96_0Z352oqZcyKTv_jxU5Hd99ZMLEhZqkXAwB5nfJvl_O4Ht9gWJkWFTNtsCTT-udmjGF8wLmN5LUs0bcpxeaA46_7TAIWmfWw5qD18CvRjKjIPhoSR81z0WUPn_4NkcZ4KxJw',
  },
  configUrl: 'https://config-service-cdn.api-cms.prd.univisionnow.com',
};
